import React, {Component} from 'react';
import {LevelTrackerMainComponent} from "../StudentsComponent/Common";
import ribbonYellow from '../assets/images/label_yellow.png'
let mazeCriteria = [1, 1,2, 3, 4, 5, 5, 6, 6, 7, 7, 8];

class ProgressBox extends Component {

    constructor(props) {
        super(props);
    }
    render() {
        let animalMap = [];
        let maxlevel = this.props.maxLevel || 12;
        let animationDelay = 0.1;
        for (let i = 1; i <= maxlevel; i++) {
            animalMap.push(<div key={i} style={{display: "inline-block"}}>
                <img
                    className={ this.props.level >= i ? "img-responsive levelAnimation" : "img-responsive noAnimation"}
                    src={require(`../assets/images/levels/medal_level${i-1}.png`)}
                    title={`Level ${i}`}
                    alt={`Level ${i}`}
                    style={{opacity: this.props.level >= i ? 1 : 0.3, filter: this.props.level >= i ? 'none' : 'grayscale(100%)', width:70, marginRight:5, animationDelay: this.props.level >= i ? (animationDelay + i-1)/2 + 's' : (this.props.level + 0.8)/2 +'s'}}
                />
            </div>)
        }
        return (
            <div className={"container"} style={{width: "100%"}}>
                <div className="row">
                       <div className={"ribbonWrapper"}>
                           <div className="ribbonYellow">Level {this.props.level > this.props.maxLevel ? this.props.maxLevel : this.props.level}</div>
                       </div>
                    <br/>
                    <div style={{marginBottom:20}}>{animalMap}</div>
                    <br/>

                    {!this.props.noDescription && this.props.appName !== "maze" && !this.props.slashProgress && this.props.level !== this.props.maxLevel + 1 ?
                        <div className="row" style={{marginBottom:15}}>
                            <p>I need to score <b>{this.props.level + 2}</b> correct.<br/>
                                </p>
                        </div>
                        : null
                    }

                    {!this.props.noDescription && this.props.appName === "maze" && !this.props.slashProgress && this.props.level !== this.props.maxLevel + 1 ?
                        <div className="row" style={{marginBottom:15}}>
                            <p>I need to score <b>{mazeCriteria[this.props.level -1]}</b> correct.<br/>
                            </p>
                        </div>
                        : null
                    }

                    {!this.props.noDescription && this.props.slashProgress ?
                        <div className="row" style={{marginBottom:15}}>
                            {/*<p>If you reach step <b> 6 </b> you will go up a level. <br />*/}
                                {/*If you go back to step <b>0</b> you will go down a level. <br /> You will always begin a new level at step 2<br/></p>*/}
                        </div>
                        : null
                    }
                    <LevelTrackerMainComponent
                        level={this.props.level || 1}
                        step={this.props.step || 1}
                        steps={this.props.steps || 6}
                        maxlevel = {this.props.maxLevel}
                        appName={this.props.appName}
                    />
                </div>
            </div>
        );
    }
}

export default ProgressBox;
